import React from "react";

// Material UI
import { Stack, Typography, Container, Switch } from "@mui/material";

// Styles
import { textStyles, commonStyles } from "Common/Styles";

// React DnD
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

// Components
import { CardInfo } from "Common/Components";

// Common
import {
  messagesTypeFields,
  MessageEditor,
  MoreInfoAccordion,
  MessagePreview,
} from "../../Common";

const NotificationSettingsPage = ({
  formik,
  allClients,
  isCustomMessagesChecked,
  setIsCustomMessagesChecked,
  setStepFieldsMap,
  viewOnly = false,
}) => {
  const client = allClients?.find((c) => c.id === formik.values.clientId);

  const handleSwitchChange = (e, client) => {
    const checked = e.target.checked;
    formik.setFieldValue("customMessagesEnabled", checked);
    setIsCustomMessagesChecked(checked);

    if (checked && Object.keys(formik.values.customTextMessages).length === 0) {
      formik.setFieldValue("customTextMessages", client?.defaultTextMessages);
    }

    // Update the stepFieldsMap to include or exclude "customTextMessages"
    setStepFieldsMap((prev) => {
      const notificationFields = [...prev["Notification Settings"]];
      if (checked) {
        if (!notificationFields.includes("customTextMessages")) {
          notificationFields.push("customTextMessages");
        }
      } else {
        const idx = notificationFields.indexOf("customTextMessages");
        if (idx > -1) {
          notificationFields.splice(idx, 1);
        }
      }
      return {
        ...prev,
        "Notification Settings": notificationFields,
      };
    });
  };

  return (
    <>
      <Container sx={{ ...commonStyles.paperContainer, pt: 2 }}>
        <Typography sx={textStyles.title}>
          Custom Text Message Settings
        </Typography>
        <Stack
          direction="row"
          sx={{ minWidth: "100%", justifyContent: "space-between", gap: 1 }}
        >
          <Typography sx={textStyles.infoText}>
            {isCustomMessagesChecked
              ? "Custom messages are enabled. You can enter a personalized message for this clinic below. To revert to the client’s default message, disable the toggle."
              : "This clinic is currently using the client’s default message. To create a custom message for this clinic, enable the toggle and enter your message below."}
          </Typography>
          <Switch
            checked={formik.values.customMessagesEnabled}
            onChange={(e) => handleSwitchChange(e, client)}
            disabled={viewOnly}
            sx={commonStyles.terracottaSwitch}
          />
        </Stack>
      </Container>
      <MoreInfoAccordion clinic={formik.values} />
      {isCustomMessagesChecked && !viewOnly ? (
        <DndProvider backend={HTML5Backend}>
          {messagesTypeFields.map((field) => (
            <MessageEditor
              key={field.id}
              formik={formik}
              field={{ ...field, multiline: true }}
              formikValue="customTextMessages"
            />
          ))}
        </DndProvider>
      ) : (
        messagesTypeFields.map((field) => {
          return (
            <CardInfo
              key={field.id}
              title={field.label}
              tooltipInfo={field.helperText}
              isHeading={false}
            >
              <MessagePreview
                formik={formik}
                field={field}
                formikValue={
                  isCustomMessagesChecked
                    ? "customTextMessages"
                    : "defaultTextMessages"
                }
                {...(!isCustomMessagesChecked && { currentClient: client })}
                clinic={formik.values}
              />
            </CardInfo>
          );
        })
      )}
    </>
  );
};

export default NotificationSettingsPage;
